// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { wrapFunction } from '../utils';
import TabClose from './TabClose';
import TabIcon from './TabIcon';
import TabLabel from './TabLabel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TabListItem = _ref => {
  let {
    tab,
    selected,
    onClick,
    monospacedWidth,
    baseClassName,
    isFake = false,
    tabPanelId,
    id
  } = _ref;
  const {
    title,
    label,
    icon,
    onActivate,
    onClose,
    component = 'a',
    style = {},
    ...tabProps
  } = tab.props;
  const closable = typeof onClose === 'function';
  const linkProps = isFake ? {
    tabIndex: -1
  } : {
    tabIndex: tabProps.tabIndex || 0,
    onClick,
    onKeyDown: wrapFunction(tabProps.onKeyDown, e => {
      if (e.key === 'Enter') {
        e.currentTarget.click();
      }
    }),
    role: 'tab',
    'aria-controls': selected ? tabPanelId : undefined,
    'aria-selected': selected || undefined,
    id,
    ...tabProps
  };
  const Tag = isFake ? 'a' : component;
  return /*#__PURE__*/_jsx("li", {
    className: classNames(`${baseClassName}__tab`, selected && `${baseClassName}__tab--selected`, closable && `${baseClassName}__tab--closable`),
    role: isFake ? undefined : 'presentation',
    children: /*#__PURE__*/_jsxs(Tag, {
      className: `${baseClassName}__link`,
      style: {
        width: monospacedWidth || undefined,
        ...style
      },
      ...linkProps,
      children: [/*#__PURE__*/_jsx(TabIcon, {
        icon: icon,
        baseClassName: baseClassName
      }), /*#__PURE__*/_jsx("span", {
        className: `${baseClassName}__tab-title`,
        children: title
      }), /*#__PURE__*/_jsx(TabLabel, {
        label: label,
        tabMode: "tab",
        baseClassName: baseClassName
      }), /*#__PURE__*/_jsx(TabClose, {
        onClose: onClose,
        tabMode: "tab",
        baseClassName: baseClassName
      })]
    })
  });
};
export default TabListItem;